
import {
  CHECKOUT_PAYMENT_LOADING,
  CHECKOUT_PAYMENT_SUCCESS,
  CHECKOUT_PAYMENT_FAILED,
  CHECKOUT_PAYMENT_NETWORK_ERROR,
  CHECKOUT_PAYMENT_RESET
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  networkError: false,
  data: {},
  description: "",
};

export default (state = initialState, action) => {
  switch (action.type) {

    case CHECKOUT_PAYMENT_LOADING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        networkError: false,
        data: {},
        description: ""
      };

    case CHECKOUT_PAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        networkError: false,
        data: action.payload,
        description: action.payload.status,
      };

    case CHECKOUT_PAYMENT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        networkError: false,
        data: action.payload,
        description: action.payload.description
      };

    case CHECKOUT_PAYMENT_NETWORK_ERROR:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        networkError: true,
        data: action.payload,
        description: "Cannot connect to the server !"
      };


    case CHECKOUT_PAYMENT_RESET:
      return (state = initialState);


    default:
      return state;
  }
};
